import Grid2 from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Chip } from "./Chip";

interface AttributeProps {
  componentName: string;
  label: string;
  value: string | string[] | Date | React.ReactNode;
  renderChip?: boolean;
  url?: string;
}

export const Attribute = ({
  componentName,
  label,
  value,
  renderChip = false,
  url,
}: AttributeProps) => {
  const formatValue = (val: string | Date): string =>
    val instanceof Date ? val.toLocaleDateString() : val?.toString();

  const isRenderableAsChip =
    typeof value === "string" || Array.isArray(value) || value instanceof Date;

  const content =
    renderChip && isRenderableAsChip ? (
      <Chip value={value} componentName={componentName} />
    ) : (
      <Typography variant="body2">
        {Array.isArray(value)
          ? value.length > 0
            ? value.map(formatValue).join(", ")
            : "None selected"
          : value instanceof Date
            ? formatValue(value)
            : typeof value === "string"
              ? value
              : (value ?? "None")}
      </Typography>
    );

  return (
    <Grid2
      data-testid={`${componentName}-Attribute`}
      container
      flexDirection="row"
      columnSpacing={1}
      sx={{ m: 0.5 }}
    >
      <Grid2>
        <Typography variant="key">{label}:</Typography>
      </Grid2>
      <Grid2 sx={{ flexWrap: "wrap" }}>
        {url ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            {content}
          </a>
        ) : (
          content
        )}
      </Grid2>
    </Grid2>
  );
};
